"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Rethrows an error catched in a catch block.
 * Might be used to log the error to the console and continue with the regular error handling.
 * @param {function} fn
 * @example
 * import { rethrowError } from 'promise-frites';
 *
 * const logError = (error) => console.error(error);
 * const displayErrorOnScreen = (error) => { // some magic };
 *
 * Promise.resolve()
 *   .then(() => { throw 'something unexpected'; })
 *   .catch(rethrowError(logError))
 *   .catch(displayErrorOnScreen);
 */

var rethrowError = exports.rethrowError = function rethrowError(fn) {
  return function (error) {
    return Promise.resolve().then(function () {
      return fn(error);
    }).then(function () {
      throw error;
    });
  };
};